export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('openForm');
    },
    openTable({commit}) {
        commit('openTable');
    },
    openExpenditureForm({commit}) {
        commit('openExpenditureForm');
    },
    modifyEuSzolgAzonositoToSelect({commit}, euszolgAzonosito) {
        commit('modifyEuSzolgAzonositoToSelect', euszolgAzonosito);
    }
}
